/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Select } from '@atoms';

import { NARROW_COL } from '@constants';
import Form from '../Form';

const AssetLanguageSelect = ({ ...props }) => {
  const [languageIndex, setLanguageIndex] = React.useState('en');

  const placeholder = '- Choose a language -';
  const languageMap = [
    {
      id: 'en',
      label: 'English',
    },
    {
      id: 'fr',
      label: 'French',
    },
    {
      id: 'es',
      label: 'Spanish',
    },
    {
      id: 'zh',
      label: 'Chinese',
    },
    {
      id: 'pt',
      label: 'Portuguese',
    },
    {
      id: 'ar',
      label: 'Arabic',
    },
    {
      id: 'tr',
      label: 'Turkish',
    },
    {
      id: 'ru',
      label: 'Russian',
    },
  ];

  return (
    <Form.Item wrapperCol={NARROW_COL} {...props}>
      <Select value={languageIndex} placeholder={placeholder} onSelect={setLanguageIndex} style={{ width: '100%' }}>
        {languageMap.map(({ label, id }, idx) => (
          <Select.Option key={idx} value={id}>
            {label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default AssetLanguageSelect;
